import {
  AlertTriangle,
  Bell,
  Bot,
  Download,
  FileText,
  LayoutDashboard,
  Package,
  Settings,
  Shield,
  ShieldCheck,
  ShieldPlus,
  ShieldUser,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { ManifestDoc } from './docsManifest';

/**
 * Screen-key prefixes → the icon the app's own navigation shows for that
 * screen (TAB_CONFIG), so the full-docs navigation reads like the sidebar.
 * Longest match wins; order does not matter.
 */
const SCREEN_ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  inventory: ShieldCheck,
  alerts: Bell,
  'shadow-ai': Bot,
  'agents-activity': Package,
  'browser-agent-sites': Package,
  policies: Shield,
  'secure-ai-coding-enforcement': ShieldPlus,
  'threat-modeling': ShieldPlus,
  'llm-vulnerability-discovery': ShieldPlus,
  users: Users,
  'security-groups': ShieldUser,
  'security-group-detail': ShieldUser,
  settings: Settings,
  'audit-logs': FileText,
  'attack-demonstrations': AlertTriangle,
  'get-started': Download,
};

/** The icon for a doc: its first screen's, or a page for docs about no screen. */
export function docIcon(doc: Pick<ManifestDoc, 'screenKeys'>): LucideIcon {
  const screenKey = doc.screenKeys[0];
  if (!screenKey) return FileText;
  const prefix = Object.keys(SCREEN_ICONS)
    .filter(key => screenKey === key || screenKey.startsWith(`${key}-`))
    .sort((a, b) => b.length - a.length)[0];
  return prefix ? SCREEN_ICONS[prefix] : FileText;
}
